import { render, staticRenderFns } from "./newNuclein.vue?vue&type=template&id=0bc57753&scoped=true&"
import script from "./newNuclein.vue?vue&type=script&lang=js&"
export * from "./newNuclein.vue?vue&type=script&lang=js&"
import style0 from "./newNuclein.vue?vue&type=style&index=0&id=0bc57753&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc57753",
  null
  
)

export default component.exports